import styled from 'styled-components';

const ScreenSharingLayoutWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export default ScreenSharingLayoutWrapper;
